<template>
  <div class="whatsapp-profile-settings">
    <h1 class="settings-title">
      Manage WhatsApp Profile
    </h1>
    <!--<button-->
    <!--class="btn btn-main btn-round mb-3"-->
    <!--@click="openTemplateMessageModal()">-->
    <!--Submit New Template Message-->
    <!--</button>-->
    <div class="settings-form">
      <b-col
        md="12"
        lg="7"
        class="px-0 float-left">
        <b-form-group>
          <label
            for="merchant-name"
            class="settings-label pt-0">
            Company Name
          </label>
          <b-input
            v-model="merchantData.name"
            v-validate="'required'"
            :placeholder="placeholders.name"
            name="merchant_name"
            data-vv-as="Company Name"
            type="text"/>
          <span
            v-if="errors.has('name')"
            class="validation-error">{{ errors.first('merchant_name') }}</span>
          <span
            v-if="validationErrors.name"
            class="validation-error">{{ validationErrors.name }}</span>
        </b-form-group>
        <b-form-group>
          <label
            for="about"
            class="settings-label pt-0">
            About (Optional)
          </label>
          <b-input
            v-model="merchantData.about"
            :placeholder="placeholders.about"
            name="about"
            data-vv-as="About"
            type="text"/>
          <span
            v-if="validationErrors.about"
            class="validation-error">{{ validationErrors.about }}</span>
        </b-form-group>
        <b-form-group>
          <label
            for="merchant-name"
            class="settings-label pt-0">
            Address (Optional)
          </label>
          <b-input
            id="address-autocomplete"
            v-model="merchantData.address"
            :placeholder="placeholders.address"
            name="address"
            data-vv-as="Address"
            type="text"/>
          <span
            v-if="validationErrors.address"
            class="validation-error">{{ validationErrors.address }}</span>
        </b-form-group>
        <b-form-group>
          <label
            for="email"
            class="settings-label pt-0">
            Email (Optional)
          </label>
          <b-input
            v-model="merchantData.email"
            :placeholder="placeholders.email"
            name="email"
            data-vv-as="Email"
            type="text"/>
          <span
            v-if="validationErrors.email"
            class="validation-error">{{ validationErrors.email }}</span>
        </b-form-group>
        <b-form-group>
          <label
            for="website"
            class="settings-label pt-0">
            Website (Optional)
          </label>
          <b-input
            v-model="merchantData.website"
            :placeholder="placeholders.website"
            name="website"
            data-vv-as="Website"
            type="text"/>
          <span
            v-if="validationErrors.website"
            class="validation-error">{{ validationErrors.website }}</span>
        </b-form-group>
        <b-form-group>
          <label
            for="description"
            class="settings-label pt-0">
            Description (Optional)
          </label>
          <b-input
            v-model="merchantData.description"
            :placeholder="placeholders.description"
            name="description"
            data-vv-as="Description"/>
          <span
            v-if="validationErrors.description"
            class="validation-error">{{ validationErrors.description }}</span>
        </b-form-group>
        <b-form-group>
          <label
            for="description"
            class="settings-label pt-0">
            Profile Photo (Optional)
          </label>
          <div class="upload-zone">
            <template v-if="!imageLoading">
              <file-upload
                ref="fileUpload"
                :drop="true"
                :extensions="['jpg', 'png']"
                accept="image/jpeg,image/png"
                @input-file="inputFile">
                <div>
                  Drop image here or
                  <br>
                  <span class="btn btn-main btn-round mt-2">Select image</span>
                  <br>
                  <span class="comment mt-2">Recommended an image with dimensions of 640x640 and max size of 63KB.</span>
                </div>
              </file-upload>
            </template>
            <div
              v-else
              class="loading"><div class="loader"><div class="loading-circle"/></div>
            </div>
          </div>
          <span
            v-if="validationErrors.logo"
            class="validation-error">{{ validationErrors.logo }}</span>
        </b-form-group>
        <div class="clearfix"/>
        <div
          v-if="merchantProfileUpdated"
          class="success-info">
          Profile info has been successfully updated.
        </div>
        <div
          v-if="errorMessage"
          class="error-message">
          {{ errorMessage }}
        </div>
        <b-button
          :class="{loading: saving}"
          :disabled="saving"
          class="btn-round btn-save"
          @click="saveMerchantProfileData">
          <span v-if="!saving">Save</span>
          <div class="loader"><div class="loading-circle"/></div>
        </b-button>
      </b-col>
      <b-col
        md="12"
        lg="5"
        class="px-0 float-left">
        <div class="phone-mockup">
          <div class="whatsapp-profile scroll-area">
            <span
              :style="merchantData.logo ? `background-image: url(${merchantData.logo})` : ''"
              class="logo"/>
            <div class="details-header">
              <div class="details-box clearfix">
                <div class="box-left">
                  <div class="name-phone">
                    <h6
                      :class="{placeholder: !merchantData.name}"
                      class="name">{{ merchantData.name || placeholders.name }}</h6>
                    <span class="phone">{{ phoneNumber }}</span>
                  </div>
                </div>
                <div class="box-right">
                  <div class="cta-icons">
                    <img src="~@/assets/img/wa-chat.svg">
                    <img src="~@/assets/img/wa-video.svg">
                    <img src="~@/assets/img/wa-phone.svg">
                  </div>
                </div>
              </div>
              <div class="status-box">
                <p
                  :class="{placeholder: !merchantData.about}"
                  class="status">{{ merchantData.about || placeholders.about }}</p>
                <p class="date">{{ currentDate }}</p>
              </div>
            </div>
            <div class="space"/>
            <div class="details-center">
              <div class="business-tag-box">
                <p class="business">Business Account</p>
              </div>
              <div class="description-box">
                <p
                  :class="{placeholder: !merchantData.description}"
                  class="description">{{ merchantData.description || placeholders.description }}</p>
              </div>
            </div>
            <div class="space"/>
            <div class="details-footer">
              <div class="address-box">
                <p
                  :class="{placeholder: !merchantData.address}"
                  class="address">{{ merchantData.address || placeholders.address }}</p>
              </div>
              <div
                :class="{placeholder: !merchantData.website}"
                class="link-box">
                <span>{{ merchantData.website || placeholders.website }}</span>
              </div>
              <div
                :class="{placeholder: !merchantData.email}"
                class="link-box">
                <span>{{ merchantData.email || placeholders.email }}</span>
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import FileUpload from 'vue-upload-component';
import { injectScript } from '@/helpers/scriptInjection';
import setValidationErrors from '@/helpers/validationErrors';

export default {
  name: 'WhatsappProfileSettings',
  components: {
    FileUpload,
  },
  data() {
    return {
      merchantData: {
        name: '',
        about: '',
        address: '',
        website: '',
        email: '',
        description: '',
        logo: '',
      },
      placeholders: {
        name: 'Acme',
        about: 'We are now on WhatsApp, come say hello!',
        address: '75 E W Santa Clara St, San Jose, CA 95113, USA',
        website: 'acme.com',
        email: 'support@acme.com',
        description: 'WhatsApp Messaging Handled.',
      },
      fileData: {
        icon: '',
        name: '',
      },
      autocomplete: null,
      saving: false,
      merchantProfileUpdated: false,
      imageLoading: false,
      currentDate: this.$moment().format('D MMM, YYYY'),
      fileErrorMessage: '',
      errorMessage: '',
      validationErrors: {},
    };
  },
  computed: {
    ...mapGetters({
      merchant: 'merchant/merchant',
      merchantLoaded: 'merchant/merchantLoaded',
      phoneNumber: 'merchant/whatsappPhoneNumber',
      merchantUpdated: 'merchant/merchantUpdated',
      apiError: 'merchant/apiError',
      googleApiKey: 'system/googleApiKey',
    }),
  },
  watch: {
    merchantLoaded(loaded) {
      if (loaded) {
        this.setMerchantData();
      }
    },
    // eslint-disable-next-line func-names
    'merchant.logo': function (logo) {
      if (logo) {
        this.imageLoading = false;
        this.merchantData.logo = logo;
      }
    },
    merchantUpdated(updated) {
      if (updated) {
        this.saving = false;
        this.merchantProfileUpdated = true;
        setTimeout(() => {
          this.merchantProfileUpdated = false;
        }, 3000);
      }
    },
    apiError(error) {
      this.saving = false;
      this.imageLoading = false;
      if (error.status === 422) {
        this.validationErrors = setValidationErrors(error.data.errors);
      } else {
        this.errorMessage = error.data.message;
      }
    },
  },
  mounted() {
    if (this.merchantLoaded) {
      this.setMerchantData();
    }
    const addressAutocomplete = document.getElementById('address-autocomplete');
    injectScript('google', `https://maps.googleapis.com/maps/api/js?libraries=places&key=${this.googleApiKey}`)
      .then(() => {
        this.autocomplete = new window.google.maps.places.Autocomplete(addressAutocomplete);
        this.autocomplete.addListener('place_changed', () => {
          const place = this.autocomplete.getPlace();
          this.address = place.formatted_address;
        });
      });
  },
  methods: {
    ...mapActions({
      updateMerchant: 'merchant/updateMerchant',
      updateLogo: 'merchant/updateLogo',
    }),
    setMerchantData() {
      this.merchantData = this.$lodash.pick(this.merchant, [
        'name',
        'about',
        'address',
        'website',
        'email',
        'description',
        'logo',
      ]);
    },
    saveMerchantProfileData() {
      this.saving = true;
      this.validationErrors = {};
      this.errorMessage = '';

      this.updateMerchant({
        merchant_id: this.$route.params.merchant_id,
        data: this.merchantData,
      });
    },
    inputFile(file) {
      if (file) {
        this.imageLoading = true;
        this.validationErrors.logo = '';

        const formData = new FormData();
        formData.append('logo', file.file);

        this.updateLogo({
          merchant_id: this.$route.params.merchant_id,
          data: formData,
        });
      }
    },
  },
};
</script>
